import { render } from "./PolarAreaChart.vue?vue&type=template&id=0c62e027&scoped=true"
import script from "./PolarAreaChart.vue?vue&type=script&lang=js"
export * from "./PolarAreaChart.vue?vue&type=script&lang=js"

import "./PolarAreaChart.vue?vue&type=style&index=0&id=0c62e027&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c62e027"]])

export default __exports__